import {Component, OnDestroy, OnInit} from '@angular/core';
import {FinanceService} from '../../../services/api/finance.service';
import {FinanceProfileModel, FinanceWalletModel, ForecastModel} from '../../../models/finance.model';
import {AlertService} from '../../../services/notify/alert.service';
import {ModalService} from '../../../services/modal/modal.service';
import {HelpersService} from '../../../services/helpers.service';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-finance-control',
    templateUrl: './finance-control.component.html',
    styleUrls: ['./finance-control.component.scss'],
})

export class FinanceControlComponent implements OnInit, OnDestroy {
    isLockButton = false;

    financeProfile: FinanceProfileModel;

    selectedWallet: FinanceWalletModel = null;

    isLoadingData = false;
    isLoadingDataError = false;

    masterWallet: FinanceWalletModel = null;
    slaveWallets: FinanceWalletModel[] = [];
    contractsWallets: FinanceWalletModel[] = [];

    /** {projectWallets / contractWallets} переключатель для адаптивки */
    adaptiveWalletType = 'projectWallets';

    showDonut = false;
    donutData: { labels: string[], datasets: [{ data: number[] }] } = {
        labels: [],
        datasets: [
            {
                data: [],
            },
        ],
    };
    allTotal: number;
    options: any;

    swapName = {
        incoming_approved_total: 'Подтвержденные аккредитивы поступления',
        incoming_promised_total: 'Ожидаемые аккредитивы поступления',
        outcoming_approved_total: 'Подтвержденные аккредитивы оплаты',
        outcoming_promised_total: 'Ожидаемые аккредитивы оплаты',
        total: 'Всего доступно на счетах',
    };


    forecastData: any;

    forecastTotalData: ForecastModel;

    financeTotalSum = 0;
    financeInTotalApproveSum = 0;
    financeOutTotalApproveSum = 0;

    constructor(
        protected financeService: FinanceService,
        protected alert: AlertService,
        public modalService: ModalService,
        public helper: HelpersService,
        private translate: TranslateService
    ) {
    }

    ngOnInit(): void {
        this.options = {
            cutout: '60%',
        };

        this.getForecast().then(() => {
            this.onLoad();
        });
    }

    async getForecast(): Promise<void> {
        return new Promise(resolve => {
            this.financeService.getMoneyInfo().subscribe(res => {
                this.forecastTotalData = res.forecast.forecast_total;

                this.financeTotalSum = parseInt(res.forecast.forecast_total.total, 10);
                if (res.forecast.forecast_total.incoming_approved_total) {
                    this.financeInTotalApproveSum = parseInt(res.forecast.forecast_total.incoming_approved_total, 10);
                }
                if (res.forecast.forecast_total.outcoming_approved_total) {
                    this.financeOutTotalApproveSum = parseInt(res.forecast.forecast_total.outcoming_approved_total, 10);
                }

                this.forecastData = res.forecast.forecast_wallets;
                for (const elem of Object.entries(res.forecast.forecast_total)) {
                    if (elem[0] !== 'total') {
                        this.donutData.labels.push(this.swapName[elem[0]]);
                        this.donutData.datasets[0].data.push(elem[1] ? Number(elem[1]) : 0);
                    } else {
                        this.allTotal = Number(elem[1]);
                    }
                }
                this.showDonut = true;
                resolve();
            });
        });
    }

    onLoad(refresh = false): void {
        this.isLoadingDataError = false;
        this.isLoadingData = true;
        this.financeService.getFinance().subscribe({
            next: res => {
                this.financeProfile = res.purse;
                this.masterWallet = res.purse.wallets.find(x => x.is_master);
                this.slaveWallets = res.purse.wallets.filter(x => !x.is_master && !x.contract_guid);
                this.contractsWallets = res.purse.wallets.filter(x => !x.is_master && x.contract_guid);
                this.isLoadingData = false;
                if (refresh) {
                    void this.getForecast();
                }
            }, error: err => {
                this.isLoadingData = false;
                this.isLoadingDataError = true;
                this.alert.setAlert(err.message, 'blue');
            },
        });
    }

    ngOnDestroy(): void {
        this.financeProfile = null;
    }


    onCreateWallet(walletTitle: string, modal: NgbModalRef): void {
        if (!walletTitle) {
            this.alert.setAlert(this.translate.instant('ALERTS.CREATE_WALLET'), 'blue');
        } else {
            this.isLockButton = true;
            this.financeService.createWallet(walletTitle).subscribe({
                next: _ => {
                    this.alert.setAlert(this.translate.instant('ALERTS.SUCCESS'), 'green');
                    modal.close();
                    this.onLoad(true);
                    this.isLockButton = false;
                }, error: err => {
                    this.alert.setAlert(err.message, 'blue');
                    this.isLockButton = false;
                },
            });
        }
    }
}
